import { useQuery } from '@tanstack/react-query';
import type { Link, SanityImage } from '@time-line/components/types';
import groq from 'groq';
import { ASSET_DECORATIVE } from 'lib/queries';
import { client } from 'lib/sanity';

export interface BannerCard {
  title: string;
  cta: Link;
  backgroundImage: SanityImage;
  backgroundImageWide: SanityImage;
}

export const BANNER_CARD_KEY = 'bannerCard';

export const fetchBannerCard = async () => {
  const query = groq`
    *[_id == "settings"][0].bannerCard {
      title,
      cta { title, href },
      backgroundImage { ${ASSET_DECORATIVE} },
      backgroundImageWide { ${ASSET_DECORATIVE} }
    }
  `;

  return client.fetch<BannerCard | null>(query);
};

export const useBannerCard = () =>
  useQuery({ queryKey: [BANNER_CARD_KEY], queryFn: fetchBannerCard });
